module.exports = __webpack_public_path__ + "static/media/PC5.ffcf393e.png";